export default __webpack_public_path__ + "static/media/stopwatch_red.5df41dee.svg";